import { isRecord } from '../is';

export function camelizeString(key: string) {
  return key.replace(
    // Capture the character after a space, underscore, period, or dash
    // and convert it to uppercase, removing the non-word character.
    /[\s_.-](\w|$)/g,
    (_, x) => x.toUpperCase(),
  );
}

export function camelize<T>(object: unknown): T {
  // If the object in question isn't a record, strictly, speaking, just return it.
  if (!isRecord(object)) {
    return object as T;
  }

  // Iterate over the keys and camelize each, setting the value.
  // If the value is a record, let's recursively camelize that as well,
  // however, if it's an array, let's iterate over each item of the array
  // and potentially camelize that as well.
  const result = Object.keys(object).reduce((memo, key) => {
    let value = object[key];

    if (isRecord(value)) {
      value = camelize(value);
    } else if (Array.isArray(value)) {
      value = value.map(camelize);
    }

    memo[camelizeString(key)] = value;
    return memo;
  }, {} as Record<string, unknown>);

  return result as T;
}
